#============================  ==================================
clipping = (svg, width, height, margin, graph_id) ->
  defs = svg.append("svg:defs")
  gradient_h = defs.append("svg:linearGradient")
      .attr("id", "alpha_h")
#        .attr("x1", "0%")
#        .attr("y1", "0%")
#        .attr("x2", "100%")
#        .attr("y2", "100%")
#        .attr("spreadMethod", "pad");

  gradient_h.append("svg:stop")
      .attr("offset", "0%")
      .attr("stop-color", "#fff")
      .attr("stop-opacity", 0);

  gradient_h.append("svg:stop")
      .attr("offset", "100%")
      .attr("stop-color", "#fff")
      .attr("stop-opacity", 0.5);


  gradient_v = defs.append("svg:linearGradient")
      .attr("id", "alpha_v")
      .attr("x1", "0%")
      .attr("y1", "100%")
      .attr("x2", "0%")
      .attr("y2", "0%")
#        .attr("spreadMethod", "pad");

  gradient_v.append("svg:stop")
      .attr("offset", "0%")
      .attr("stop-color", "#fff")
      .attr("stop-opacity", 0);

  gradient_v.append("svg:stop")
      .attr("offset", "100%")
      .attr("stop-color", "#fff")
      .attr("stop-opacity", 0.5);


  mask = defs.append("svg:mask")
        .attr("id", "mask_#{graph_id}")

  # Left Gradient
  mask.append("svg:rect")
        .attr("width", margin.left)
        .attr("height", height+margin.bottom)
        .attr("y", 0)
        .attr("x", -margin.left)
        #.style("z-index", 10)
        .style("fill", "url(#alpha_h)");

  # Bottom Gradient
  mask.append("svg:rect")
        .attr("width", width)
        .attr("height", margin.bottom)
        .attr("x", 0)
        .attr("y", height)
        #.style("z-index", 10)
        .style("fill", "url(#alpha_v)");

  # Solid middle
  mask.append("svg:rect")
        .attr("x", 0)
        .attr("y", 0)
        .attr("width", width)
        .attr("height", height)
        #.style("z-index", 10)
        .style("fill", "white");

  defs.append("svg:clipPath")
        .attr("id", "clip_#{graph_id}")
      .append("rect")
        .attr("x", -margin.left)
        .attr("y", -margin.top)
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)

#============================ Line Graphs ==================================
class D3LineGraph extends gs.GraphBase
  constructor: (element, context, axis_height) ->
    # TODO: Graph loading indiciator when no useful data to show.
    #         Minor loading indicator when some data missing.

    super element, context, axis_height
    @margin =
      top: 10
      right: 20
      bottom: 30
      left: 50

    num_axes = @context.structured.length
    if num_axes == 1
      axis_height *= 2

    @width = $(@element).width() - @margin.left - @margin.right
    @height = num_axes * (axis_height + @margin.top)

    @x = d3.time.scale().range([0, @width])
    @rendered_x = d3.time.scale().range([0, @width])

    @x_int = d3.scale.linear().range([0, @width])
    @xAxis = d3.svg.axis().scale(@x).orient("bottom")
    @zoom_active = false

    @dragging = false

    $(window).bind "resize.d3_graph_#{@id}", $.throttle 500, =>
      @do_resize()

    ko.utils.domNodeDisposal.addDisposeCallback @element, =>
      # Remove event bindings
      $(window).unbind("resize.d3_graph_#{@id}");

    gs.bindings.fullscreen.subscribe =>
      @do_resize()

    # SVG Transform zoom
    zoomed = =>
      #@container.attr("transform", "translate(#{d3.event.translate[0]},0), scale(#{d3.event.scale},1)")
      zoom_anim = false
      if !zoom_anim
        zoom_anim = true
        requestAnimFrame =>
          zoom_anim = false
          @x_axis.call(@xAxis)

          [new_start, new_end] = @x.domain()
          if not gs.loading_mgr.loading() and new_start < @ready_start or new_end > @ready_end
            # Get data for this now larger window in time.
            @update_data()
          else
            @calc_transform()
      #@y_axis.call(@yAxis)
#      @y_origin
#        .attr("y1", @y(0))
#        .attr("y2", @y(0))
#        .attr("x1", 0)
#        .attr("x2", @width)

      @dragging = true
      if @context.mgr.hover_time()?
        @context.mgr.hover_time null

        #rule.style("display", "none")


    zoomend = =>
      @dragging = false

      [new_start, new_end] = @x.domain()

      @context.mgr.start new_start
      @context.mgr.end new_end

    dragstarted = (d) =>
      d3.event.sourceEvent.stopPropagation()
      d3.select(this).classed "dragging", true
    dragged = (d) =>
      #d3.select(this).attr("cx", d.x = d3.event.x).attr "cy", d.y = d3.event.y
    dragended = (d) =>
      d3.select(this).classed "dragging", false


    @zoom = d3.behavior.zoom()
      .x(@x)
#      .y(@y)
#      .scaleExtent([0.5, 10])
      .on("zoom", zoomed)
      .on("zoomend", zoomend)

    @drag = d3.behavior.drag()
      #.origin((d) -> d)
      .on("dragstart", dragstarted)
      .on("drag", dragged)
      .on("dragend", dragended)

    # Set up containers
    @outer_svg = d3.select(@element)
      .append("svg")
      .attr("width", @width + @margin.left + @margin.right)
      .attr("height", @height + @margin.top + @margin.bottom)
    @svg = @outer_svg.append("g")
      .attr("transform", "translate(" + @margin.left + "," + @margin.top + ")")

    @svg.append("g")
      .append("svg:clipPath")
        .attr("id", "clip_#{@id}")
      .append("rect")
        .attr("x", 0)
        .attr("y", 0)
        .attr("width", @width)
        .attr("height", @height)

    zoom_rect = @outer_svg.append("rect")
        .attr("class", "zoom_indicator")
        .attr("stroke", "none")
        .attr("stroke-width", "3")
        .attr("fill", "none")
        .attr("width", @width + @margin.left + @margin.right)
        .attr("height", @height + @margin.top + @margin.bottom)

    @container_wrapper = @svg.append("g")
      .attr("clip-path", "url(#clip_#{@id})")

    @container = @container_wrapper.append("g")

    # Background rect to catch mouse events.
    rect = @svg.append("rect")
      .attr("width", @width)
      .attr("height", @height)
      .style("fill", "none")
      .style("pointer-events", "all");

    @x_axis = @svg
      .append("g")
      .attr("class", "x axis")
      .attr("transform", "translate(0," + @height + ")")

    # Generate the axes.
    @axes = {}
    base_y = 0
    for {unit:unit, nodes:nodes} in @context.structured
      @axes[unit] = do =>
        y = d3.scale.linear().range([axis_height + base_y, base_y])

        yAxis = d3.svg.axis().scale(y).orient("left")

        line = d3.svg.line()
          #.x((d, i) => @x(new Date(@ready_start).add(@g_span * i).minutes()) )
          .y((d, i) => y(d) )
          .defined((d) => !isNaN(d))

        y_axis = @svg
          .append("g")
          .attr("class", "y axis")

        unit_details = gs.get_unit(unit)
        if unit_details?
          y_axis
            .append("text")
            .attr("transform", "rotate(-90)")
            .attr("y", 6)
            .attr("dy", ".71em")
            .attr("x", -base_y - 5)
            .style("text-anchor", "end")
            .text(unit_details.axis)

        #y_origin = @container_wrapper
        #  .append("line")
        #    .attr("class", "origin")

        base_y += axis_height + @margin.top
        return {y: y, yAxis: yAxis, line: line, y_axis:y_axis, unit: unit_details, unit_raw: unit} #, y_origin:y_origin

#    rule = d3.select(element).append("div").attr("class", "rule").attr("id", "rule_#{@id}")
#                             .append("div").attr("class", "rule_line")
#                              .style("display", "none")
#
#    ruleStyle = (line) ->
#      line.style("position", "fixed")
#        .style("top", 0)
#        .style("bottom", 0)
#        .style("width", "1px")
#        .style("pointer-events", "none")
#
#    ruleStyle(rule)
#    rule.style("left", "100px")

    cursor = @container_wrapper
                  .append("circle")
                  .attr("class", "little")
                  .attr("cx", 1)
                  .attr("cy", 1)
                  .attr("r", 6)
                  .attr("fill", "green")
                  .style("display", "none")

    rect.on "mousemove", =>
      return if @dragging

      [x,y] = d3.mouse(rect.node())
      #console?.log x, y
      #cursor.attr("cx", x).attr("cy", y).style("display", null)
      #@render_left(x)
      last_hover = @context.mgr.hover_time()
      next_hover = @x.invert(x) # Causes graphs to render hover times.
      return unless last_hover is null or Math.abs(next_hover - last_hover) > 1000 * @g_freq

      ms_per_freq = (1000 * @g_freq)
      next_hover = new Date(Math.round(next_hover / ms_per_freq) * ms_per_freq)
      @context.mgr.hover_time next_hover

    rect.on "mouseout", =>
      #cursor.style("display", "none")
      @context.mgr.hover_time null
      #@render_left(@width - 150)
      if @zoom_active
        @zoom_active = false
        zoom_rect.attr("stroke", "none")
        @svg
          .on(".zoom", null)


    rect.on "mousedown", =>
      if not @zoom_active
        @zoom_active = true
        zoom_rect.attr("stroke", "green")
        @svg
          .call(@zoom)
          .on("dblclick.zoom", null)


#    rect.on "mousedown", ->
#      #cursor.attr("r", 3)
#      #      .attr("fill", "red")
#
#    rect.on "mouseup", ->
#      #cursor.attr("r", 6)
#      #      .attr("fill", "green")

    @left_deets = @svg.append("g")
        .attr("class", "hover_details left_deets")
    @left_deets.append("svg:rect")
        .attr("class", "background")
        .attr("fill", "#f7f5f5")
        .attr("opacity", 0.8)
        .attr("x", 1)
        .attr("width", 150)
        .attr("height", @height)
        .style("pointer-events", "none")
    @left_deets.append("text")
        .attr("class", "time_stamp")
    @left_deets.append("line")
        .attr("class", "rule_line")
        .attr("x1", 0)
        .attr("x2", 0)
        .attr("y1", 0)
        .attr("y2", @height)
        .style("stroke", "#000")


    @anim_left = false
    @context.mgr.hover_time.subscribe (value) =>
      return if @anim_left
      @anim_left = true
      requestAnimFrame =>
        @anim_left = false
        @render_left(@context.mgr.hover_time())

  do_resize: =>
    # Call when you think that the graph's width might have changed.
    requestAnimFrame =>
      new_width = $(@element).width() - @margin.left - @margin.right
      if new_width != @width
        @width = new_width
        @x.range([0, @width])
        @rendered_x.range([0, @width])

        @zoom.x(@x)
        #console?.log "D3LineGraph width changed to #{@width}"

        d3.select(@element).select("svg").attr("width", @width + @margin.left + @margin.right)
        @svg.select("g > rect").attr("width", @width)

        @svg.select("rect")
          .attr("width", @width)

        @render_lines()
        @calc_transform()
        @render_left(@context.mgr.hover_time.peek())

  render_left: (timestamp) =>
    # For each axis: Object with name, value, color.

    #timestamp = @x.invert(x)
    if timestamp?
      x = @x(timestamp)
      show_time = true # show time
      @left_deets.select("rect").attr("opacity", 0.8)

    else
      show_time = false # hide time
      x = @width - 100
      timestamp = @x.invert(x) # so we can get values and put labels in a good spot.
      @left_deets.select("rect").attr("opacity", 0.9)

    return unless @data_param?

    for data_line in @data_param
      data_val = gs.find_nearest_value(data_line.data, timestamp)
      data_line.hover_left = data_val
      if data_val?
        data_line.hover_y_loc = @axes[data_line.unit].y(data_val) - 5
      else
        data_line.hover_y_loc = @axes[data_line.unit].y.range()[1]

    @left_deets.attr("transform", "translate(#{x}, 0)")

    if @context.mgr.is_live()
      time_str =  timestamp.toString('HH:mm:ss')
    else
      time_str =  timestamp.toString('HH:mm ddd, d MMM yyyy')

    @left_deets.select(".time_stamp")
                  .attr("y", 0)
                  .attr("x", 2)
                  .style("fill", "#000")
                  .text(time_str)
                  .attr("display", if show_time then null else "none")
                  .style("pointer-events", "none")

    @left_deets.select(".rule_line")
                .style("display", if show_time then null else "none")
                .style("pointer-events", "none")


    @seperate_labels()

    detail_groups = @left_deets.selectAll("text.readout").data(@data_param, (d)=>"#{d.id}_#{d.unit}")
    detail_groups.enter().append("text").attr("y", "0")
#                 .append("G")
    detail_groups.exit().remove()
    detail_groups.style("pointer-events", "none")
                  #.attr("dy", ".71em")
                  .attr("class", "readout")
                  .attr("x", if show_time then 2 else 10)
                  .attr("font-size", "1.2em")
#                  .style("text-anchor", "end")
                  .style("fill", (d)=>d.color)
                  .text(if show_time then (d) => "#{d.hover_left?.toFixed(1)} #{d.unit}: #{d.name}" else (d)->d.name)
                  .attr("y", (d) =>d.hover_y_loc)
  post_init: =>
    super()

  get_start_end: => @x.domain()

  update_data: =>
    return if not @context or @context.cursors().length == 0

    if !@dragging
      start = @context.mgr.start();
      end = @context.mgr.end();
      @x.domain [start, end]
      @zoom.x(@x)
      @calc_transform()
    else
      [start, end] = @x.domain()

    line_redraw_req = @get_graph_data() | @g_force_repaint

    @update_data_param()
    #console?.log "Graph update_data. Redraw req:", line_redraw_req, @data_param[0].data[0].data, @data_param, "wait load:", @wait_load, "loading:", gs.loading_mgr.loading()

    if line_redraw_req
      @g_force_repaint = false
      for {unit: unit} in @context.structured
        axis = @axes[unit]
        [min, max] = @y_range(@ready_data, axis.unit.incl_origin, start, end, unit)
        axis.y.domain [min,max]
        axis.y_axis
          .call(axis.yAxis)

      @render_lines()
      @calc_transform()
      @render_left(@context.mgr.hover_time.peek())

  do_queued_draw: =>
    @g_repainting = false
    @update_data()

  calc_transform: =>
    @x_axis
      .call(@xAxis)

    x_lhs = @rendered_x(@x.invert(0))
    x_rhs = @rendered_x(@x.invert(@width))
    x_range = @width / (x_rhs - x_lhs)
    #x_range = (@x.domain()[1] - @rendered_x.domain()[1]) - x_translate

    #range = (x_range[1] - x_range[0]) / 1000.0
    @container.attr("transform", "scale(#{x_range},1) translate(#{ -x_lhs },0)")

  render_lines: =>
    return unless @ready_data? and @ready_data.length > 0

    local_axes = @axes
    local_x = @x
    @rendered_x.domain @x.domain() # Copy domain for use in transform.

    lines = @container
      .selectAll(".line")
      .data(@data_param, (d) -> "#{d.id}_#{d.unit}")

    lines.enter().append('g').attr('class','line')
    lines.exit().remove()
    lines.each (parentDatum) ->
        line = local_axes[parentDatum.unit]?.line
        segs = d3.select(this).selectAll('.line_seg').data(parentDatum.data, (d)-> d.start_time)
        segs.enter().append('path')
        segs.attr('class','line_seg')
          .attr("vector-effect","non-scaling-stroke")
          .style("stroke", parentDatum.color)
          .attr "d", (d, outer_i) ->
            return null unless d.data.length > 0

            local_base_time = gs.to_local(d.start_time)

            if d.freq < 5 * 60
              # High resolution data. Clip to the part that is visible.
              [start, end] = local_x.domain()
              start = gs.to_utc(start).add(-d.freq * 60).seconds()
              end = gs.to_utc(end).add(d.freq * 60).seconds()

              first_idx = Math.round((start - d.start_time) / (1000 * d.freq), 0)
              last_idx = Math.round((end - d.start_time) / (1000 * d.freq), 0)
              if first_idx >= d.data.length or last_idx < 0
                # no data to render
                return null

              if first_idx < 0
                first_idx = 0
              else
                local_base_time = gs.to_local(start)

              if last_idx >= d.data.length then last_idx = d.data.length - 1

              line.x (inner_d, i) => local_x(new Date(local_base_time).add(seconds:d.freq * i))
              return line(d.data[first_idx..last_idx], outer_i)
            else
              line.x (inner_d, i) => local_x(new Date(local_base_time).add(seconds:d.freq * i))
              return line(d.data, outer_i)
        segs.exit().remove()

#============================ Custom KO Bindings ==================================
# Binding for Gridspy graphs, pulling in data from the requested day and rendering it to the page.
ko.bindingHandlers.gsIntervalGraph =
  init: (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) ->
    console?.log
    args = ko.unwrap(valueAccessor())
    context = ko.unwrap(args['context'])
    axis_height = ko.unwrap(args['axis_height']) or 100

    element.gs_graph = new D3LineGraph(element, context, axis_height)
    element.gs_graph.post_init()

  update: (element, valueAccessor, allBindingsAccessor, viewModel) ->
    console?.log
    args = ko.unwrap(valueAccessor())
    context = ko.unwrap(args['context'])
    axis_height = ko.unwrap(args['axis_height']) or 100

    if context != element.gs_graph.context
      element.gs_graph = new D3LineGraph(element, context, axis_height)
      element.gs_graph.post_init()

ko.bindingHandlers.gsRadioSummary =
  init: (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) ->
    #Variables can be put here.

    margin = {top: 20, right: 20, bottom: 30, left: 40}
    width = 960 - margin.left - margin.right
    height = 900 - margin.top - margin.bottom

    bands = 8
    band_offset = height / bands
    band_padding = 2
    band_height = band_offset - band_padding
    nodes_width = 50

    x = d3.scale.ordinal()
      .rangeRoundBands([nodes_width, width - nodes_width], .7)

    # Colors for Good and Bad Packets
    color = d3.scale.ordinal()
      .range(["#a1c110", "#ff6633"])

    # Signal strength bars
    y_signal = d3.scale.linear()
      .range([band_height, 0])
      .domain([-10, -110])
      .clamp(true)

    y = d3.scale.linear()
      .range([band_height, 0])

    y_gd_bd = d3.scale.linear()
      .range([band_height, 0])

    # Background colors for channel performance
    chan_pos_color = d3.scale.ordinal()
      .domain([-1, 255, 63, 0,2,3,4,5,6,7])
      .range(["#FFFFFF","#FFFFFF","#FFFFFF","#F5F4FD","#D2D0FD","#BFBCFF","#8C85FF","#5A50FF", "#372BFD", "#2219B2" ])

    svg = d3.select(element).append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
      .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")")

    channels = svg.append('g').attr('class','channels')

    proc_gd_bd = (d) ->
      y0 = 0
      block_data = [d.num_gd, d.num_bd]
      d.blocks = color.domain().map (idx) -> return {name: name, y0: y0, y1: y0 += +block_data[idx]}
      d.total = d.blocks[d.blocks.length - 1].y1
      return d

    create_gd_bd = (channel_squares, x, width) ->
      channel_blocks = channel_squares.selectAll(".gd_bd")
        .data((d)-> d.blocks)

      channel_blocks.enter().append("rect")
        .attr("class", "gd_bd")
        .attr("width", width)
        .attr("x", x)
        .style("fill", (d, i) -> return color(i) )

      channel_blocks.transition()
        .delay((d,i) -> i*20)
        .duration(1000)
        .attr("y", (d, i) -> return y_gd_bd(d.y1))
        .attr("height", (d) -> return y_gd_bd(d.y0) - y_gd_bd(d.y1) )


    element.gsRadioSummary_data = ko.observable {}
    element.gsIntervalGraph_render = ko.computed
      read: ->
        return if not $(element).is(':visible')

        #{} = element.gsRadioSummary_data()
        return if not gs.bindings.inst?
        summary = gs.bindings.inst.radio_summary()
        return if not summary.channels?

        channel_nums = (i for i in [0..summary.channels.length])
        color.domain([0,1])

        node_list = (proc_gd_bd(summary.nodes[idx]) for own idx of summary.nodes)

        nodes = svg.selectAll(".node")
          .data(node_list)

        # For each node
        node_grp = nodes.enter().append('g')
            .attr('class','node')
            .attr("transform", (d, i ) -> "translate(0, #{band_offset * (i + 1)})" )

        node_grp.append('text')
            .text((d)->d.sn)
            .attr('x', 20)
            .attr('y', 30)

        node_grp.append('g')
            .attr('class','all_gd_bd')

        node_grp.append("rect")
          .attr("class", "db_avg")
          .attr("width", 2)
          .attr("x", 2)
          .style("fill", '#777')

        nodes.each (node_data, node_idx)->
          node = d3.select(this)

          # Create overall node success graph and DB meter
          node.select(".all_gd_bd")
          overall_gd_bd = node.select(".all_gd_bd")
          y_gd_bd.domain([0, node_data.total])
                 .range([band_height, 40])
          create_gd_bd(overall_gd_bd, 20, 20)

          node.select(".db_avg").transition()
            .delay((d,i) -> i*20)
            .duration(1000)
            .attr("y", (d) -> band_height - y_signal(d.db_avg))
            .attr("height", (d) -> y_signal(d.db_avg))

          # Create channels
          channel_data = node_data.channels.map proc_gd_bd

          x.domain channel_nums
          y_gd_bd.domain([0, d3.max(channel_data, (d) -> d.total )])
                 .range([band_height, 0])


          channel_squares = node.selectAll(".channel")
            .data(channel_data)

          # Channel Blocks
          channel_g = channel_squares.enter().append('g')
            .attr("class", 'channel')
            .attr("transform", (d, i ) -> "translate(#{x(i)},0)" )

          channel_g.append("rect")
            .attr("class", "bg") #Background
            .attr("width", (d, i) -> x(i+1) - x(i) - 4)
            .attr("height", band_height)
            .style("fill", "none")
            .style("stroke", (d)->chan_pos_color(d.chan_pos))

          channel_g.append("rect")
            .attr("class", "db_avg")
            .attr("width", 2)
            .attr("x", 2)
            .style("fill", '#777')

          # Good / Bad Stacked graph
          create_gd_bd(channel_squares, x.rangeBand() + 2, x.rangeBand())

          channel_squares.select(".db_avg").transition()
            .delay((d,i) -> i*20)
            .duration(1000)
            .attr("y", (d) -> band_height - y_signal(d.db_avg))
            .attr("height", (d) -> y_signal(d.db_avg))

          channel_squares.select('.bg').transition()
            .duration(500)
            .style("stroke", (d)->chan_pos_color(d.chan_pos))


        # Channel list at top
        do ->
          channel_data = summary.channels.map proc_gd_bd

          y.domain [0, d3.max(channel_data, (d) -> d.total )]

          x.domain channel_nums

          channel_squares = channels.selectAll(".channel")
              .data(channel_data)

          channel_squares.enter()
            .append('g')
              .attr("class", 'channel')
              .attr("transform", (d, i ) -> "translate(" + x(i) + ",0)" )
            .append('text')
              .attr('class', 'freq')
              .text((d) -> d.freq)
              .attr("font-size", "0.8em")
              .attr("transform", "translate(10, #{band_height}), rotate(-90, 0, 0)")

          # Good and bad packet blocks
          create_gd_bd(channel_squares, x.rangeBand() + 2, x.rangeBand())


  update: (element, valueAccessor, allBindingsAccessor, viewModel) ->
    # Prepare the data and render the relevant graph. Should the data change, that will trigger another
    #  call to this function.
    args = valueAccessor()

    # code goes here to update the data
    #gsRadioSummary_data {}
